import React from 'react';
import { Switch, useTheme, makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
    root: {
        width: 82,
        height: 36,
        padding: 0,
        margin: theme.spacing(1),
        fontSize: 16
      },
      switchBase: {
        padding: 1,
        '&$checked': {
          transform: 'translateX(46px)',
          color: theme.palette.success.main,
          '& + $track': {
            border: `1px solid ${theme.palette.grey[500]}`,
            backgroundColor: '#ffffff',
            opacity: 1,
            '&::after': {
                content: '"On"',
                paddingLeft: 16,
                fontWeight: 500,
                color: theme.palette.grey[600],
            }
          },
          '& $thumb': {
            color: theme.palette.success.main
          },
        }
      },
      thumb: {
        color: theme.palette.grey[400],
        width: 34,
        height: 34,
      },
      track: {
        borderRadius: 36 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[200],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
        '&::after': {
            content: '"Off"',
            fontWeight: 500,
            color: theme.palette.grey[500],
            display: 'block',
            paddingLeft: 43,
            paddingTop: 7
        }
      },
      checked: {},
      focusVisible: {},
}));


const PowerSwitch = props => {

    const theme = useTheme();
    const classes = useStyles(theme);

    const handleSwitchChange = e => {
        if(typeof props.handleSwitchChange === 'function')
            props.handleSwitchChange(e);
    }

    return (
        <Switch
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            checked={props.checked}
            onChange={handleSwitchChange}
            name={props.name}
        />
    )
}

export default PowerSwitch